import React from "react";

// eslint-disable-next-line css-modules/no-unused-class
import css from "./StatusIcon.module.scss";

type Props = {
  status?: "awarded" | "preTender" | "openTender";
};

export default function StatusIcon({ status }: Props) {
  if (!status) {
    return null;
  }

  const statusText = (() => {
    switch (status) {
      case "awarded":
        return "Awarded contract";
      case "preTender":
        return "Pre-tender";
      case "openTender":
        return "Open tender";
    }
  })();

  return (
    <div className={`${css.statusIcon} ${css[status]}`}>
      <p className={css.statusText}>{statusText}</p>
    </div>
  );
}
